export default "__VITE_ASSET__ThESC8oe__"